import { ErrorHandler, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { UserService } from '../user/user.service';
import { GlobalSettingsService } from './global-settings.service';


@Injectable({
  providedIn: 'root'
})
export class WhatsNewService {
  localStorageInfo = this._globalSettingsService.localStorageInfo$;

  constructor(private _http: HttpClient,
              private _errorHandler: ErrorHandler,
              private _userService: UserService,
              private _globalSettingsService: GlobalSettingsService) { }

  getWhatsNew(version: string): Promise<any> {
    try {
      const URL = `${environment.airportsApiUrl}/whatsnew/?application=Airports&version=${version}`;
      const response = this._http.get(URL).toPromise();
      // console.log('response: ', response);
      return response;
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }

  async shouldShowWhatsNew(): Promise<boolean> {
    const userPrefWhatsNewVersion = await this._userService.getWhatsNewVersion();
    this._globalSettingsService.loadInfo();
    let showWhatsNew = true;
    this.localStorageInfo.subscribe(val => {
      if (val && val.whatsNewVersion && val.whatsNewVersion === environment.version) { showWhatsNew = false; }
    });
    if (userPrefWhatsNewVersion && userPrefWhatsNewVersion === environment.version) { showWhatsNew = false; }
    return showWhatsNew;
  }

  async displayedWhatsNew() {

    this._globalSettingsService.setInfo({
      whatsNewVersion: environment.version
    });
    await this._userService.saveWhatsNewVersion();

  }
}
